module.exports = fox._r("images/empty-icon-model.png", __webpack_public_path__ + "_/_/_/common/frame/images/empty-icon-model.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/empty-icon-model.png
// module id = 95
// module chunks = 2